import { NgModule } from '@angular/core';

import { PopoverModule } from 'primeng/popover';  // Renamed from OverlayPanelModule

import { ValidatableControlDirective } from 'sc-common/shared/validatable/validatable.directive';
import { ValidationErrorsLabelComponent } from 'sc-common/shared/validatable/validation-errors-label.component';
import { ValidationErrorsTooltipComponent } from 'sc-common/shared/validatable/validation-errors-tooltip.component';

@NgModule({
    imports: [
        PopoverModule  // Renamed from OverlayPanelModule
    ],
    exports: [
        ValidatableControlDirective,
        ValidationErrorsLabelComponent,
        ValidationErrorsTooltipComponent
    ],
    declarations: [
        ValidatableControlDirective,
        ValidationErrorsLabelComponent,
        ValidationErrorsTooltipComponent
    ],
    providers: []
})
export class ValidatableModule { }
